import { useRouter } from 'next/router';
export var TYPEFORM_APPLY_LINK = "https://segment.typeform.com/to/S6MSYuLt/";
export var AIRTABLE_PARTNER_LINK = "https://airtable.com/shr84MIvVo4k8xbaO?prefill_Segment%20Code=Ad-Landing-Page&hide_Segment%20Code=true";

var useStartupLinks = function useStartupLinks() {
  var router = useRouter(); // Get the current route's query string

  var queryString = Object.keys(router.query).map(function (key) {
    return "".concat(key, "=").concat(router.query[key]);
  }).join("&");
  return {
    applyLink: queryString ? "".concat(TYPEFORM_APPLY_LINK, "?").concat(queryString) : TYPEFORM_APPLY_LINK,
    partnerLink: queryString ? "".concat(AIRTABLE_PARTNER_LINK, "&").concat(queryString) : AIRTABLE_PARTNER_LINK
  };
};

export default useStartupLinks;